import {StringArray} from '../@interfaces/types';
import app from './app';

export default function trans_choice(
	key: string,
	number: number | any[] | Record<any, any>,
	replace?: StringArray<string | number>,
	defaultValue?: string | null,
	locale?: string
): string {
	return app('trans').choice(key, number, replace, defaultValue ?? key, locale) as string;
}
